import { SPI, ActionWidget, ActionType, ViewActionTarget } from '@kunlun/dependencies';
import { formTableImportV2 } from './formTableImportV2/formTableImportV2';

@SPI.ClassFactory(
  ActionWidget.Token({
    widget: 'FormTableImportV2',
    name: [
      // 区域推广方案商品详情导入
      'uiViewc5707cb40212410eab9364129510ad45',
      // 品牌推广方案商品详情导入
      'uiView1648cb41abf546729d9d566721850fd9'
    ],
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog, ViewActionTarget.Router, ViewActionTarget.Inner]
  })
)
export class PlanItemDetailImport extends formTableImportV2 {
  public initialize(config: any): this {
    super.initialize(config);

    this.enableUniqueDatasource = false;

    return this;
  }
}
